import { createContext, useContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const SelectableButtonContext = /*#__PURE__*/createContext(undefined);
export const SelectableButtonProvider = ({
  selectableButtonStyleOverrides,
  children
}) => {
  return /*#__PURE__*/_jsx(SelectableButtonContext.Provider, {
    value: {
      selectableButtonStyleOverrides
    },
    children: children
  });
};

/**
 * Provides the context for the `SelectableButton` component.
 * Note: The context is only available when the `SelectableButton` component is rendered as an ancestor.
 * @returns SelectableButtonContext - The context for the `SelectableButton` component.
 * @returns SelectableButtonContext.selectableButtonStyleOverrides - Style overrides to be applied to the `SelectableButton` component.
 */
export const useSelectableButtonContext = () => {
  return useContext(SelectableButtonContext);
};